<div *ngIf="sticker" [ngStyle]="{ width: '180px', 'min-height': '180px' }" class="sticker-content">
  <div
    *ngIf="sticker.mime_type === 'application/x-tgsticker'; else imageSticker"
    (deferVizible)="getLottie($event)"
    [style.height.px]="180"
    class="sticker"
  >
    <ng-lottie
      *ngIf="options"
      [styles]="lottieStyles"
      [options]="options"
      (loopComplete)="onLoopComplete()"
      (animationCreated)="animationCreated($event)"
    ></ng-lottie>
  </div>
  <ng-template #imageSticker>
    <div class="h-100" (deferLoad)="getFileSrc(sticker)">
      <div
        *ngIf="!sticker.file_uri; else stickerThumb"
        class="d-flex h-100 flex-column justify-content-center align-items-center text-center"
      >
        <i-feather *ngIf="!sticker?.file_uri_error; else errorImage" class="icon-xxl" name="smile"></i-feather>
      </div>
      <ng-template #stickerThumb>
        <img
          loading="lazy"
          *ngIf="!sticker?.file_uri_error; else errorImage"
          (error)="loadImageError($event)"
          class="img-fluid w-100 h-auto"
          [src]="sticker.file_uri"
        />
      </ng-template>
    </div>
  </ng-template>
</div>

<ng-template #errorImage>
  <div class="d-flex h-100 flex-column justify-content-center align-items-center text-center">
    <div tooltip="Ошибка загрузки стикера">
      <i-feather class="icon-xxl" name="alert-octagon"></i-feather>
    </div>
  </div>
</ng-template>
